import template from "./quick-open-modal.html";
import "./quick-open-modal.less";
import { ROLE_TYPES } from "../../../config/permissions";
import {
	FORM_REPORT_QUERY,
	EDIT_REPORT
} from "../../../routes";

export function controller(
	$scope,
	$state,
	$userProfile,
	entityManager,
	api,
	appState,
	toastr,
	loadingService
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.handleClose = handleClose;
	ctrl.handleGo = handleGo;
	ctrl.handleKeyPress = handleKeyPress;
	ctrl.handleEntitySelect = handleEntitySelect;
	ctrl.setSelectBox = setSelectBox;
	ctrl.setMode = setMode;
	ctrl.handleModeKeydown = handleModeKeydown;

	ctrl.mode = "number"; // "id" or "number"
	ctrl.goToValue = null;
	ctrl.selectedEntity = null;
	ctrl.defaultSelection = { primary: {}, friendly: {} };
	ctrl.entities = [];
	ctrl.showIdOption = false;
	ctrl.selectBox = null;
	ctrl.promiseTracker = loadingService.getTracker();

	function onInit() {
		ctrl.form = appState.forms.selected;

		// Check if user is agent or sysadmin to show Id option
		const user = $userProfile.getUser();
		ctrl.showIdOption = user.roles.indexOf(ROLE_TYPES.sysAdmin) > -1 
			|| user.roles.indexOf(ROLE_TYPES.agent) > -1;

		// Get primary entities (friendlies)
		ctrl.entities = entityManager.getPrimaryFieldEntities() || [];
		
		// Auto-select if only one entity
		if(ctrl.entities.length === 1) {
			ctrl.selectedEntity = ctrl.entities[0];
			ctrl.defaultSelection = { primary: {}, friendly: ctrl.entities[0] };
		}
	}

	function setSelectBox(selectBox) {
		ctrl.selectBox = selectBox;
	}

	function setMode(mode) {
		ctrl.mode = mode;
	}

	function handleModeKeydown(event, currentMode) {
		const modes = ["number", "id"];
		const currentIndex = modes.indexOf(currentMode);
		let newIndex = currentIndex;

		if(event.keyCode === 37 || event.keyCode === 38) { // Left or Up
			event.preventDefault();
			newIndex = currentIndex === 0 ? modes.length - 1 : currentIndex - 1;
		}
		else if(event.keyCode === 39 || event.keyCode === 40) { // Right or Down
			event.preventDefault();
			newIndex = currentIndex === modes.length - 1 ? 0 : currentIndex + 1;
		}

		if(newIndex !== currentIndex) {
			ctrl.mode = modes[newIndex];
			// Focus the new button after digest
			$scope.$applyAsync(() => {
				const buttons = document.querySelectorAll(".quick-open-modal-body [role='radio']");
				if(buttons[newIndex]) {
					buttons[newIndex].focus();
				}
			});
		}
	}

	function handleEntitySelect(selection) {
		if(selection && selection.friendly) {
			ctrl.selectedEntity = selection.friendly;
		}
		else if(selection && selection.primary) {
			ctrl.selectedEntity = selection.primary;
		}
		else {
			ctrl.selectedEntity = null;
		}
	}

	function handleKeyPress(event) {
		if(event.keyCode === 13) { // Enter key
			handleGo();
		}
	}

	async function handleGo() {
		if(!ctrl.goToValue) {
			toastr.warning("Please enter a value");
			return;
		}

		if(ctrl.mode === "id") {
			// Navigate directly to report by ID
			$state.go(EDIT_REPORT, { id: ctrl.goToValue });
			handleClose();
		}
		else {
			// Number mode - need to search first
			if(!ctrl.selectedEntity) {
				toastr.warning("Please select an entity");
				return;
			}

			// Build entity IDs from selected entity
			let entityIds = [];
			if(ctrl.selectedEntity.Entities && ctrl.selectedEntity.Entities.length > 0) {
				entityIds = ctrl.selectedEntity.Entities.map(e => e.Entity.Id);
			}
			else {
				entityIds = [ctrl.selectedEntity.Id];
			}

			const params = {
				BeginDate: "1900/01/01",
				EndDate: "2100/12/31",
				EntityIds: entityIds,
				beginNumber: ctrl.goToValue,
				endNumber: ctrl.goToValue
			};

			const url = FORM_REPORT_QUERY(ctrl.form.Id, params);
			
			const promise = api.get(url)
				.then(response => {
					if(response && response.length === 1) {
						$state.go(EDIT_REPORT, { id: response[0].Id });
						handleClose();
					}
					else if(response && response.length > 1) {
						toastr.warning("Multiple reports found with that number. Please use the report list to find the correct one.");
					}
					else {
						toastr.warning("No report found with that number");
					}
				})
				.catch(() => {
					toastr.error("Failed to search for report");
				});

			ctrl.promiseTracker.addPromise(promise);
		}
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}
}

export default angular
	.module("vesl.components.quick-open-modal", [])
	.component("quickOpenModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
